module.exports = __webpack_public_path__ + "img/1.fbe1775e.jpg";